import type { Logger } from '@kinopoisk-int/logger';

import {
    IYandexMetrikaApi,
    IYandexMetrikaReachGoalHandler,
    IYandexMetrikaParamsHandler,
    IYandexMetrikaService,
    IYandexMetrikaServiceParams,
    YandexMetrikaMethods,
    YandexMetrikaHitHandler,
} from './types';

export class YandexMetrikaService implements IYandexMetrikaService {
    private metrikaApi: IYandexMetrikaApi;

    private debug: boolean;

    private getLogger?: () => Logger;

    constructor({ metrikaApi, debug = false, getLogger }: IYandexMetrikaServiceParams) {
        this.metrikaApi = metrikaApi;
        this.debug = debug;
        this.getLogger = getLogger;
    }

    get ymclidPromise() {
        return this.metrikaApi.ymclidPromise;
    }

    reachGoal: IYandexMetrikaReachGoalHandler = (...args) => {
        if (this.debug && this.getLogger) {
            this.getLogger().debug({ arguments: args }, '[YandexMetrikaService::reachGoal]');
        }

        this.metrikaApi.emit({
            type: YandexMetrikaMethods.reachGoal,
            payload: args,
        });
    };

    params: IYandexMetrikaParamsHandler = (...args) => {
        if (this.debug && this.getLogger) {
            this.getLogger().debug({ arguments: args }, '[YandexMetrikaService::params]');
        }

        this.metrikaApi.emit({
            type: YandexMetrikaMethods.params,
            payload: args,
        });
    };

    hit: YandexMetrikaHitHandler = (...args) => {
        if (this.debug && this.getLogger) {
            this.getLogger().debug({ arguments: args }, '[YandexMetrikaService::hit]');
        }

        this.metrikaApi.emit({
            type: YandexMetrikaMethods.hit,
            payload: args,
        });
    };
}
